module.exports = __webpack_public_path__ + "static/media/step-solution4.75ead710.svg";